import React from 'react'
import cx from 'classnames'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import { connect } from 'react-redux'

import HeaderLogo from './Logo'
import Userbox from './Userbox'
import LanguageSwitcher from 'components/LanguageSwitcher'

const Header = ({
  headerBackgroundColor,
  enableMobileMenuSmall,
  enableHeaderShadow,
  history,
  onClickToggleProfileModal,
  user,
  userType
}) => {
  return (
    <>
      <ReactCSSTransitionGroup
        component="div"
        className={ cx("app-header", headerBackgroundColor, {'header-shadow': enableHeaderShadow}) }
        transitionName="HeaderAnimation"
        transitionAppear={ true }
        transitionAppearTimeout={ 1500 }
        transitionEnter={ false }
        transitionLeave={ false }>
        <HeaderLogo />
        <div className={ cx( "app-header__content", { 'header-mobile-open': enableMobileMenuSmall } ) }>
          <div className="app-header-left">
          </div>
          <div className="app-header-right">
            <LanguageSwitcher 
              buttonClass={ 'btn-primary' }
              userType={userType}
            />
            <Userbox 
              onClickToggleProfileModal={ onClickToggleProfileModal } 
              history={ history } 
              user={ user } />
          </div>
        </div>
      </ReactCSSTransitionGroup>
    </>
  )
}

const mapStateToProps = state => ({
  enableHeaderShadow: state.ThemeOptions.enableHeaderShadow,
  closedSmallerSidebar: state.ThemeOptions.closedSmallerSidebar,
  headerBackgroundColor: state.ThemeOptions.headerBackgroundColor,
  enableMobileMenuSmall: state.ThemeOptions.enableMobileMenuSmall
})

const mapDispatchToProps = dispatch => ({})

export default connect( mapStateToProps, mapDispatchToProps )( Header )